<template>
    <component :is="themeName" :id="themeName"/>
</template>

<script>

import Vue from 'vue'
import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'



// Load theme folder
const requireComponent = require.context('./', true, /\.layout\.vue$/i);
requireComponent.keys().forEach(fileName => {
    // console.log(fileName)

    const componentConfig = requireComponent(fileName)
    const componentName = upperFirst(
        camelCase(
            fileName.split('/')[1]
        )
    )

    Vue.component(
        componentName,
        // Look for the component options on `.default`, which will
        // exist if the component was exported with `export default`,
        // otherwise fall back to module's root.
        componentConfig.default || componentConfig
    )
})


export default {
    
    components: {
    },
    computed: {
        themeSetting () {
            return this.$store.getters['getThemeSetting']
        },
        themeName () {
            let theme = this.$TestApp.getThemeName()
            return `${theme}-layout` 
        }
    },
    data () {
        return {
        }
    },
    watch: {
    },
    methods: {
    },
    mounted() {
        setTimeout(async () => {
            this.$TestApp.userInit()
            await this.$TestApp.pageSetting()
            await this.$TestApp.trackingInit()
            this.$TestApp.checkLogin()
            

            await this.$TestApp._fetchExam()

            // Lay thong tin đề thi từ localstorage
            await this.$TestApp.loadTestInLocal()


            // check lại bài thi đã làm
            this.$TestApp.checkTestingHistory()
            .then(result => {

                if (result) {

                    this.$bvModal.msgBoxConfirm('Bạn có một bài thi đang làm, bạn có muốn tiếp tục làm bài thi này ?', {
                        title: 'Bạn vẫn còn bài thi đang làm',
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'Tôi muốn làm tiếp',
                        cancelTitle: 'Tôi muốn bắt đầu lại',
                        footerClass: 'p-2',
                        hideHeaderClose: true,
                        centered: true,
                        noCloseOnBackdrop: true
                    })
                    .then(value => {
                        if (value == true) {
                            this.$TestApp.testContinue(result)
                        } else {
                            // Không làm tiếp bài hiện tại
                            this.$TestApp.testNewSession()
                        }
                    })
                } else {
                    //
                    this.$TestApp.testNewSession()
                }
                
            })
            .catch(error => {
                console.log('checkTestingHistory: ', error)
                // this.testNewSession()
            })
        }, 500)
    },
    created() {
    },
}
</script>


<style lang="scss">

button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
}

.close {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.btn-custom.btn-success {
    background-color: #FF4A4A;
    text-transform: uppercase;
    color: #fff;
    font-weight: 900;
    font-size: 36px !important ;
    border-radius: 30px;
    line-height: 36px;
    padding: 10px 45px;
    display: inline-block;
    // border: 1px solid #46a520;
    // box-shadow: 0px 4px 2px #46a520, 0px 0px 11px 3px #ffffff5c inset;
}


.btn-custom.btn-danger {
    background-color: #FF4A4A;
    text-transform: uppercase;
    color: #fff;
    font-weight: 900;
    font-size: 36px !important ;
    border-radius: 30px;
    line-height: 36px;
    padding: 10px 45px;
    display: inline-block;
    box-shadow: 0px 4px 0px #94100d;
}

html, body, #app {
    min-height: 100% !important;
}

body, html {
    overflow-x: hidden;
}

.modal-custom {
    
    .modal-content {
        border-radius: 20px;
        border: 3px solid #000;
        box-shadow: 4px 4px 0px #008844;
    }

    .modal-header {

        position: absolute;
        top: -35px;
        left: 10px;
        border-radius: 10px;
        border: 3px solid #000;
        height: max-content;
        width: max-content;
        background: url('~@/assets/ver2/background-button.png');
        box-shadow: 4px 4px 0px #008844;
        padding: 8px 26px 8px 18px;
        

        &::after {
            content: '';
            display: block;
            background-image: url('~@/assets/ver2/icons/modal-title-el.png');
            background-repeat: no-repeat;
            background-size: contain;
            position: absolute;
            left: -50px;
            bottom: -20px;
            height: 50px;
            width: 60px;
        }

        &::before {
            content: '';
            display: block;
            background-image: url('~@/assets/ver2/icons/dots.png');
            background-repeat: no-repeat;
            background-size: contain;
            position: absolute;
            right: -80px;
            top: 50%;
            height: 20px;
            width: 60px;
        }

        & * {
            font-family: 'Montserrat', sans-serif;
            color: #fff;
            text-transform: uppercase;
            font-size: 1.2rem;
            font-weight: 900;
            font-style: italic;
            margin: 0;
            text-shadow: 3px 0 #000, -3px 0 #000, 0 2px #000, 0 -3px #000,
               2px 2px #000, -2px -2px #000, 2px -2px #000, -2px 2px #000;
        }

        .close{
            display: none;
        }
    }

}

</style>

<style>

/*!
 * Quill Editor v2.0.0-dev.3
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
/*!
 * Quill Editor v2.0.0-dev.3
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
 .ql-snow.ql-toolbar:after,.ql-snow .ql-toolbar:after {
    content: "";
    display: table
}

[dir] .ql-snow.ql-toolbar:after,[dir] .ql-snow .ql-toolbar:after {
    clear: both
}

.ql-snow.ql-toolbar button,.ql-snow .ql-toolbar button {
    display: inline-block;
    height: 24px;
    width: 28px
}

[dir] .ql-snow.ql-toolbar button,[dir] .ql-snow .ql-toolbar button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 3px 5px
}

[dir=ltr] .ql-snow.ql-toolbar button,[dir=ltr] .ql-snow .ql-toolbar button {
    float: left
}

[dir=rtl] .ql-snow.ql-toolbar button,[dir=rtl] .ql-snow .ql-toolbar button {
    float: right
}

.ql-snow.ql-toolbar button svg,.ql-snow .ql-toolbar button svg {
    height: 100%
}

[dir=ltr] .ql-snow.ql-toolbar button svg,[dir=ltr] .ql-snow .ql-toolbar button svg {
    float: left
}

[dir=rtl] .ql-snow.ql-toolbar button svg,[dir=rtl] .ql-snow .ql-toolbar button svg {
    float: right
}

.ql-snow.ql-toolbar button:active:hover,.ql-snow .ql-toolbar button:active:hover {
    outline: none
}

.ql-snow.ql-toolbar input.ql-image[type=file],.ql-snow .ql-toolbar input.ql-image[type=file] {
    display: none
}

.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item.ql-selected,.ql-snow.ql-toolbar .ql-picker-item:hover,.ql-snow .ql-toolbar .ql-picker-item:hover,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-label:hover,.ql-snow .ql-toolbar .ql-picker-label:hover,.ql-snow.ql-toolbar button.ql-active,.ql-snow .ql-toolbar button.ql-active,.ql-snow.ql-toolbar button:focus,.ql-snow .ql-toolbar button:focus,.ql-snow.ql-toolbar button:hover,.ql-snow .ql-toolbar button:hover {
    color: #06c
}

.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:focus .ql-fill,.ql-snow .ql-toolbar button:focus .ql-fill,.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:hover .ql-fill,.ql-snow .ql-toolbar button:hover .ql-fill,.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill {
    fill: #06c
}

.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow.ql-toolbar button.ql-active .ql-stroke,.ql-snow .ql-toolbar button.ql-active .ql-stroke,.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar button:focus .ql-stroke,.ql-snow .ql-toolbar button:focus .ql-stroke,.ql-snow.ql-toolbar button:focus .ql-stroke-miter,.ql-snow .ql-toolbar button:focus .ql-stroke-miter,.ql-snow.ql-toolbar button:hover .ql-stroke,.ql-snow .ql-toolbar button:hover .ql-stroke,.ql-snow.ql-toolbar button:hover .ql-stroke-miter,.ql-snow .ql-toolbar button:hover .ql-stroke-miter {
    stroke: #06c
}

@media (pointer: coarse) {
    .ql-snow.ql-toolbar button:hover:not(.ql-active),.ql-snow .ql-toolbar button:hover:not(.ql-active) {
        color:#444
    }

    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
        fill: #444
    }

    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
        stroke: #444
    }
}

.ql-snow,.ql-snow * {
    box-sizing: border-box
}

.ql-snow .ql-hidden {
    display: none
}

.ql-snow .ql-out-bottom,.ql-snow .ql-out-top {
    visibility: hidden
}

.ql-snow .ql-tooltip {
    position: absolute
}

[dir] .ql-snow .ql-tooltip {
    transform: translateY(10px)
}

.ql-snow .ql-tooltip a {
    text-decoration: none
}

[dir] .ql-snow .ql-tooltip a {
    cursor: pointer
}

[dir] .ql-snow .ql-tooltip.ql-flip {
    transform: translateY(-10px)
}

.ql-snow .ql-formats {
    display: inline-block;
    vertical-align: middle
}

.ql-snow .ql-formats:after {
    content: "";
    display: table
}

[dir] .ql-snow .ql-formats:after {
    clear: both
}

.ql-snow .ql-stroke {
    fill: none;
    stroke: #444;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2
}

.ql-snow .ql-stroke-miter {
    fill: none;
    stroke: #444;
    stroke-miterlimit: 10;
    stroke-width: 2
}

.ql-snow .ql-fill,.ql-snow .ql-stroke.ql-fill {
    fill: #444
}

.ql-snow .ql-empty {
    fill: none
}

.ql-snow .ql-even {
    fill-rule: evenodd
}

.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin {
    stroke-width: 1
}

.ql-snow .ql-transparent {
    opacity: .4
}

.ql-snow .ql-direction svg:last-child {
    display: none
}

.ql-snow .ql-direction.ql-active svg:last-child {
    display: inline
}

.ql-snow .ql-direction.ql-active svg:first-child {
    display: none
}

.ql-snow .ql-editor h1 {
    font-size: 2em
}

.ql-snow .ql-editor h2 {
    font-size: 1.5em
}

.ql-snow .ql-editor h3 {
    font-size: 1.17em
}

.ql-snow .ql-editor h4 {
    font-size: 1em
}

.ql-snow .ql-editor h5 {
    font-size: .83em
}

.ql-snow .ql-editor h6 {
    font-size: .67em
}

.ql-snow .ql-editor a {
    text-decoration: underline
}

[dir] .ql-snow .ql-editor blockquote {
    margin-bottom: 5px;
    margin-top: 5px
}

[dir=ltr] .ql-snow .ql-editor blockquote {
    border-left: 4px solid #ccc;
    padding-left: 16px
}

[dir=rtl] .ql-snow .ql-editor blockquote {
    border-right: 4px solid #ccc;
    padding-right: 16px
}

[dir] .ql-snow .ql-editor .ql-code-block-container,[dir] .ql-snow .ql-editor code {
    background-color: #f0f0f0;
    border-radius: 3px
}

[dir] .ql-snow .ql-editor .ql-code-block-container {
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 5px 10px
}

.ql-snow .ql-editor code {
    font-size: 85%
}

[dir] .ql-snow .ql-editor code {
    padding: 2px 4px
}

.ql-snow .ql-editor .ql-code-block-container {
    color: #f8f8f2;
    overflow: visible
}

[dir] .ql-snow .ql-editor .ql-code-block-container {
    background-color: #23241f
}

.ql-snow .ql-editor img {
    max-width: 100%
}

.ql-snow .ql-picker {
    color: #444;
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    height: 24px;
    position: relative;
    vertical-align: middle
}

[dir=ltr] .ql-snow .ql-picker {
    float: left
}

[dir=rtl] .ql-snow .ql-picker {
    float: right
}

.ql-snow .ql-picker-label {
    display: inline-block;
    height: 100%;
    position: relative;
    width: 100%
}

[dir] .ql-snow .ql-picker-label {
    cursor: pointer
}

[dir=ltr] .ql-snow .ql-picker-label {
    padding-left: 8px;
    padding-right: 2px
}

[dir=rtl] .ql-snow .ql-picker-label {
    padding-right: 8px;
    padding-left: 2px
}

.ql-snow .ql-picker-label:before {
    display: inline-block;
    line-height: 22px
}

.ql-snow .ql-picker-options {
    display: none;
    min-width: 100%;
    position: absolute;
    white-space: nowrap
}

[dir] .ql-snow .ql-picker-options {
    background-color: #fff;
    padding: 4px 8px
}

.ql-snow .ql-picker-options .ql-picker-item {
    display: block
}

[dir] .ql-snow .ql-picker-options .ql-picker-item {
    cursor: pointer;
    padding-bottom: 5px;
    padding-top: 5px
}

.ql-snow .ql-picker.ql-expanded .ql-picker-label {
    color: #ccc;
    z-index: 2
}

.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
    fill: #ccc
}

.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
    stroke: #ccc
}

.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    display: block;
    top: 100%;
    z-index: 1
}

[dir] .ql-snow .ql-picker.ql-expanded .ql-picker-options {
    margin-top: -1px
}

.ql-snow .ql-color-picker,.ql-snow .ql-icon-picker {
    width: 28px
}

[dir] .ql-snow .ql-color-picker .ql-picker-label,[dir] .ql-snow .ql-icon-picker .ql-picker-label {
    padding: 2px 4px
}

[dir=ltr] .ql-snow .ql-color-picker .ql-picker-label svg,[dir=ltr] .ql-snow .ql-icon-picker .ql-picker-label svg {
    right: 4px
}

[dir=rtl] .ql-snow .ql-color-picker .ql-picker-label svg,[dir=rtl] .ql-snow .ql-icon-picker .ql-picker-label svg {
    left: 4px
}

[dir] .ql-snow .ql-icon-picker .ql-picker-options {
    padding: 4px 0
}

.ql-snow .ql-icon-picker .ql-picker-item {
    height: 24px;
    width: 24px
}

[dir] .ql-snow .ql-icon-picker .ql-picker-item {
    padding: 2px 4px
}

.ql-snow .ql-color-picker .ql-picker-options {
    width: 152px
}

[dir] .ql-snow .ql-color-picker .ql-picker-options {
    padding: 3px 5px
}

.ql-snow .ql-color-picker .ql-picker-item {
    height: 16px;
    width: 16px
}

[dir] .ql-snow .ql-color-picker .ql-picker-item {
    border: 1px solid transparent;
    margin: 2px;
    padding: 0
}

[dir=ltr] .ql-snow .ql-color-picker .ql-picker-item {
    float: left
}

[dir=rtl] .ql-snow .ql-color-picker .ql-picker-item {
    float: right
}

.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    position: absolute;
    top: 50%;
    width: 18px
}

[dir] .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    margin-top: -9px
}

[dir=ltr] .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    right: 0
}

[dir=rtl] .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    left: 0
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=""]):before {
    content: attr(data-label)
}

.ql-snow .ql-picker.ql-header {
    width: 98px
}

.ql-snow .ql-picker.ql-header .ql-picker-item:before,.ql-snow .ql-picker.ql-header .ql-picker-label:before {
    content: "Normal"
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]:before {
    content: "Heading 1"
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]:before {
    content: "Heading 2"
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]:before {
    content: "Heading 3"
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]:before {
    content: "Heading 4"
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]:before {
    content: "Heading 5"
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]:before {
    content: "Heading 6"
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]:before {
    font-size: 2em
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]:before {
    font-size: 1.5em
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]:before {
    font-size: 1.17em
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]:before {
    font-size: 1em
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]:before {
    font-size: .83em
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]:before {
    font-size: .67em
}

.ql-snow .ql-picker.ql-font {
    width: 108px
}

.ql-snow .ql-picker.ql-font .ql-picker-item:before,.ql-snow .ql-picker.ql-font .ql-picker-label:before {
    content: "Sans Serif"
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]:before {
    content: "Serif"
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before {
    content: "Monospace"
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before {
    font-family: Georgia,Times New Roman,serif
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before {
    font-family: Monaco,Courier New,monospace
}

.ql-snow .ql-picker.ql-size {
    width: 98px
}

.ql-snow .ql-picker.ql-size .ql-picker-item:before,.ql-snow .ql-picker.ql-size .ql-picker-label:before {
    content: "Normal"
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]:before {
    content: "Small"
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]:before {
    content: "Large"
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]:before {
    content: "Huge"
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before {
    font-size: 10px
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before {
    font-size: 18px
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before {
    font-size: 32px
}

[dir] .ql-snow .ql-color-picker.ql-background .ql-picker-item {
    background-color: #fff
}

[dir] .ql-snow .ql-color-picker.ql-color .ql-picker-item {
    background-color: #000
}

.ql-toolbar.ql-snow {
    box-sizing: border-box;
    font-family: Helvetica Neue,Helvetica,Arial,sans-serif
}

[dir] .ql-toolbar.ql-snow {
    border: 1px solid #ccc;
    padding: 8px
}

[dir=ltr] .ql-toolbar.ql-snow .ql-formats {
    margin-right: 15px
}

[dir=rtl] .ql-toolbar.ql-snow .ql-formats {
    margin-left: 15px
}

[dir] .ql-toolbar.ql-snow .ql-picker-label {
    border: 1px solid transparent
}

[dir] .ql-toolbar.ql-snow .ql-picker-options {
    border: 1px solid transparent;
    box-shadow: 0 2px 8px rgba(0,0,0,.2)
}

[dir] .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,[dir] .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    border-color: #ccc
}

[dir] .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,[dir] .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
    border-color: #000
}

[dir] .ql-toolbar.ql-snow+.ql-container.ql-snow {
    border-top: 0
}

.ql-snow .ql-tooltip {
    color: #444;
    white-space: nowrap
}

[dir] .ql-snow .ql-tooltip {
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 0 5px #ddd;
    padding: 5px 12px
}

.ql-snow .ql-tooltip:before {
    content: "Visit URL:";
    line-height: 26px
}

[dir=ltr] .ql-snow .ql-tooltip:before {
    margin-right: 8px
}

[dir=rtl] .ql-snow .ql-tooltip:before {
    margin-left: 8px
}

.ql-snow .ql-tooltip input[type=text] {
    display: none;
    font-size: 13px;
    height: 26px;
    width: 170px
}

[dir] .ql-snow .ql-tooltip input[type=text] {
    border: 1px solid #ccc;
    margin: 0;
    padding: 3px 5px
}

.ql-snow .ql-tooltip a.ql-preview {
    display: inline-block;
    max-width: 200px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: top
}

.ql-snow .ql-tooltip a.ql-action:after {
    content: "Edit"
}

[dir=ltr] .ql-snow .ql-tooltip a.ql-action:after {
    border-right: 1px solid #ccc;
    margin-left: 16px;
    padding-right: 8px
}

[dir=rtl] .ql-snow .ql-tooltip a.ql-action:after {
    border-left: 1px solid #ccc;
    margin-right: 16px;
    padding-left: 8px
}

.ql-snow .ql-tooltip a.ql-remove:before {
    content: "Remove"
}

[dir=ltr] .ql-snow .ql-tooltip a.ql-remove:before {
    margin-left: 8px
}

[dir=rtl] .ql-snow .ql-tooltip a.ql-remove:before {
    margin-right: 8px
}

.ql-snow .ql-tooltip a {
    line-height: 26px
}

.ql-snow .ql-tooltip.ql-editing a.ql-preview,.ql-snow .ql-tooltip.ql-editing a.ql-remove {
    display: none
}

.ql-snow .ql-tooltip.ql-editing input[type=text] {
    display: inline-block
}

.ql-snow .ql-tooltip.ql-editing a.ql-action:after {
    content: "Save"
}

[dir=ltr] .ql-snow .ql-tooltip.ql-editing a.ql-action:after {
    border-right: 0;
    padding-right: 0
}

[dir=rtl] .ql-snow .ql-tooltip.ql-editing a.ql-action:after {
    border-left: 0;
    padding-left: 0
}

.ql-snow .ql-tooltip[data-mode=link]:before {
    content: "Enter link:"
}

.ql-snow .ql-tooltip[data-mode=formula]:before {
    content: "Enter formula:"
}

.ql-snow .ql-tooltip[data-mode=video]:before {
    content: "Enter video:"
}

.ql-snow a {
    color: #06c
}

[dir] .ql-container.ql-snow {
    border: 1px solid #ccc
}

/*!
 * Quill Editor v2.0.0-dev.3
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
.ql-container {
    box-sizing: border-box;
    font-family: Helvetica,Arial,sans-serif;
    font-size: 13px;
    height: 100%;
    position: relative
}

[dir] .ql-container {
    margin: 0
}

.ql-container.ql-disabled .ql-tooltip {
    visibility: hidden
}

[dir] .ql-container:not(.ql-disabled) li[data-list=checked]>.ql-ui,[dir] .ql-container:not(.ql-disabled) li[data-list=unchecked]>.ql-ui {
    cursor: pointer
}

.ql-clipboard {
    height: 1px;
    overflow-y: hidden;
    position: absolute;
    top: 50%
}

[dir=ltr] .ql-clipboard {
    left: -100000px
}

[dir=rtl] .ql-clipboard {
    right: -100000px
}

[dir] .ql-clipboard p {
    margin: 0;
    padding: 0
}

.ql-editor {
    box-sizing: border-box;
    counter-reset: list-0;
    line-height: 1.42;
    height: 100%;
    outline: none;
    overflow-y: auto;
    tab-size: 4;
    -moz-tab-size: 4;
    white-space: pre-wrap;
    word-wrap: break-word
}

[dir] .ql-editor {
    padding: 12px 15px
}

[dir=ltr] .ql-editor {
    text-align: left
}

[dir=rtl] .ql-editor {
    text-align: right
}

[dir] .ql-editor>* {
    cursor: text
}

[dir] .ql-editor blockquote,[dir] .ql-editor h1,[dir] .ql-editor h2,[dir] .ql-editor h3,[dir] .ql-editor h4,[dir] .ql-editor h5,[dir] .ql-editor h6,[dir] .ql-editor ol,[dir] .ql-editor p,[dir] .ql-editor pre {
    margin: 0;
    padding: 0
}

.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor p {
    counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9
}

.ql-editor table {
    border-collapse: collapse
}

[dir] .ql-editor td {
    border: 1px solid #000;
    padding: 2px 5px
}

[dir=ltr] .ql-editor ol {
    padding-left: 1.5em
}

[dir=rtl] .ql-editor ol {
    padding-right: 1.5em
}

.ql-editor li {
    list-style-type: none;
    position: relative
}

[dir=ltr] .ql-editor li {
    padding-left: 1.5em
}

[dir=rtl] .ql-editor li {
    padding-right: 1.5em
}

.ql-editor li>.ql-ui:before {
    display: inline-block;
    white-space: nowrap;
    width: 1.2em
}

[dir=ltr] .ql-editor li>.ql-ui:before {
    margin-left: -1.5em;
    margin-right: .3em;
    text-align: right
}

[dir=rtl] .ql-editor li>.ql-ui:before {
    margin-right: -1.5em;
    margin-left: .3em;
    text-align: left
}

.ql-editor li[data-list=checked]>.ql-ui,.ql-editor li[data-list=unchecked]>.ql-ui {
    color: #777
}

.ql-editor li[data-list=bullet]>.ql-ui:before {
    content: "\2022"
}

.ql-editor li[data-list=checked]>.ql-ui:before {
    content: "\2611"
}

.ql-editor li[data-list=unchecked]>.ql-ui:before {
    content: "\2610"
}

.ql-editor li[data-list=ordered] {
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-0
}

.ql-editor li[data-list=ordered]>.ql-ui:before {
    content: counter(list-0,decimal) ". "
}

.ql-editor li[data-list=ordered].ql-indent-1 {
    counter-increment: list-1
}

.ql-editor li[data-list=ordered].ql-indent-1>.ql-ui:before {
    content: counter(list-1,lower-alpha) ". "
}

.ql-editor li[data-list=ordered].ql-indent-1 {
    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9
}

.ql-editor li[data-list=ordered].ql-indent-2 {
    counter-increment: list-2
}

.ql-editor li[data-list=ordered].ql-indent-2>.ql-ui:before {
    content: counter(list-2,lower-roman) ". "
}

.ql-editor li[data-list=ordered].ql-indent-2 {
    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9
}

.ql-editor li[data-list=ordered].ql-indent-3 {
    counter-increment: list-3
}

.ql-editor li[data-list=ordered].ql-indent-3>.ql-ui:before {
    content: counter(list-3,decimal) ". "
}

.ql-editor li[data-list=ordered].ql-indent-3 {
    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9
}

.ql-editor li[data-list=ordered].ql-indent-4 {
    counter-increment: list-4
}

.ql-editor li[data-list=ordered].ql-indent-4>.ql-ui:before {
    content: counter(list-4,lower-alpha) ". "
}

.ql-editor li[data-list=ordered].ql-indent-4 {
    counter-reset: list-5 list-6 list-7 list-8 list-9
}

.ql-editor li[data-list=ordered].ql-indent-5 {
    counter-increment: list-5
}

.ql-editor li[data-list=ordered].ql-indent-5>.ql-ui:before {
    content: counter(list-5,lower-roman) ". "
}

.ql-editor li[data-list=ordered].ql-indent-5 {
    counter-reset: list-6 list-7 list-8 list-9
}

.ql-editor li[data-list=ordered].ql-indent-6 {
    counter-increment: list-6
}

.ql-editor li[data-list=ordered].ql-indent-6>.ql-ui:before {
    content: counter(list-6,decimal) ". "
}

.ql-editor li[data-list=ordered].ql-indent-6 {
    counter-reset: list-7 list-8 list-9
}

.ql-editor li[data-list=ordered].ql-indent-7 {
    counter-increment: list-7
}

.ql-editor li[data-list=ordered].ql-indent-7>.ql-ui:before {
    content: counter(list-7,lower-alpha) ". "
}

.ql-editor li[data-list=ordered].ql-indent-7 {
    counter-reset: list-8 list-9
}

.ql-editor li[data-list=ordered].ql-indent-8 {
    counter-increment: list-8
}

.ql-editor li[data-list=ordered].ql-indent-8>.ql-ui:before {
    content: counter(list-8,lower-roman) ". "
}

.ql-editor li[data-list=ordered].ql-indent-8 {
    counter-reset: list-9
}

.ql-editor li[data-list=ordered].ql-indent-9 {
    counter-increment: list-9
}

.ql-editor li[data-list=ordered].ql-indent-9>.ql-ui:before {
    content: counter(list-9,decimal) ". "
}

[dir=ltr] .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3em
}

[dir=rtl] .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
    padding-right: 3em
}

[dir=ltr] .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 4.5em
}

[dir=rtl] .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
    padding-right: 4.5em
}

[dir=ltr] .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 3em
}

[dir=rtl] .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-left: 3em
}

[dir=ltr] .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 4.5em
}

[dir=rtl] .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-left: 4.5em
}

[dir=ltr] .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 6em
}

[dir=rtl] .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
    padding-right: 6em
}

[dir=ltr] .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 7.5em
}

[dir=rtl] .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
    padding-right: 7.5em
}

[dir=ltr] .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 6em
}

[dir=rtl] .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-left: 6em
}

[dir=ltr] .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 7.5em
}

[dir=rtl] .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-left: 7.5em
}

[dir=ltr] .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 9em
}

[dir=rtl] .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
    padding-right: 9em
}

[dir=ltr] .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 10.5em
}

[dir=rtl] .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
    padding-right: 10.5em
}

[dir=ltr] .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 9em
}

[dir=rtl] .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-left: 9em
}

[dir=ltr] .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 10.5em
}

[dir=rtl] .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-left: 10.5em
}

[dir=ltr] .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 12em
}

[dir=rtl] .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
    padding-right: 12em
}

[dir=ltr] .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 13.5em
}

[dir=rtl] .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
    padding-right: 13.5em
}

[dir=ltr] .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 12em
}

[dir=rtl] .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-left: 12em
}

[dir=ltr] .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 13.5em
}

[dir=rtl] .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-left: 13.5em
}

[dir=ltr] .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 15em
}

[dir=rtl] .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
    padding-right: 15em
}

[dir=ltr] .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 16.5em
}

[dir=rtl] .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
    padding-right: 16.5em
}

[dir=ltr] .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 15em
}

[dir=rtl] .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-left: 15em
}

[dir=ltr] .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 16.5em
}

[dir=rtl] .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-left: 16.5em
}

[dir=ltr] .ql-editor .ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 18em
}

[dir=rtl] .ql-editor .ql-indent-6:not(.ql-direction-rtl) {
    padding-right: 18em
}

[dir=ltr] .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 19.5em
}

[dir=rtl] .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
    padding-right: 19.5em
}

[dir=ltr] .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 18em
}

[dir=rtl] .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-left: 18em
}

[dir=ltr] .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 19.5em
}

[dir=rtl] .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-left: 19.5em
}

[dir=ltr] .ql-editor .ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 21em
}

[dir=rtl] .ql-editor .ql-indent-7:not(.ql-direction-rtl) {
    padding-right: 21em
}

[dir=ltr] .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 22.5em
}

[dir=rtl] .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
    padding-right: 22.5em
}

[dir=ltr] .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 21em
}

[dir=rtl] .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-left: 21em
}

[dir=ltr] .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 22.5em
}

[dir=rtl] .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-left: 22.5em
}

[dir=ltr] .ql-editor .ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 24em
}

[dir=rtl] .ql-editor .ql-indent-8:not(.ql-direction-rtl) {
    padding-right: 24em
}

[dir=ltr] .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 25.5em
}

[dir=rtl] .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
    padding-right: 25.5em
}

[dir=ltr] .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 24em
}

[dir=rtl] .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-left: 24em
}

[dir=ltr] .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 25.5em
}

[dir=rtl] .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-left: 25.5em
}

[dir=ltr] .ql-editor .ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 27em
}

[dir=rtl] .ql-editor .ql-indent-9:not(.ql-direction-rtl) {
    padding-right: 27em
}

[dir=ltr] .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 28.5em
}

[dir=rtl] .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
    padding-right: 28.5em
}

[dir=ltr] .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 27em
}

[dir=rtl] .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-left: 27em
}

[dir=ltr] .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 28.5em
}

[dir=rtl] .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-left: 28.5em
}

[dir=ltr] .ql-editor li.ql-direction-rtl {
    padding-right: 1.5em
}

[dir=rtl] .ql-editor li.ql-direction-rtl {
    padding-left: 1.5em
}

[dir=ltr] .ql-editor li.ql-direction-rtl>.ql-ui:before {
    margin-left: .3em;
    margin-right: -1.5em;
    text-align: left
}

[dir=rtl] .ql-editor li.ql-direction-rtl>.ql-ui:before {
    margin-right: .3em;
    margin-left: -1.5em;
    text-align: right
}

.ql-editor table {
    table-layout: fixed;
    width: 100%
}

.ql-editor table td {
    outline: none
}

.ql-editor .ql-code-block-container {
    font-family: monospace
}

.ql-editor .ql-video {
    display: block;
    max-width: 100%
}

[dir] .ql-editor .ql-video.ql-align-center {
    margin: 0 auto
}

[dir=ltr] .ql-editor .ql-video.ql-align-right {
    margin: 0 0 0 auto
}

[dir=rtl] .ql-editor .ql-video.ql-align-right {
    margin: 0 auto 0 0
}

[dir] .ql-editor .ql-bg-black {
    background-color: #000
}

[dir] .ql-editor .ql-bg-red {
    background-color: #e60000
}

[dir] .ql-editor .ql-bg-orange {
    background-color: #f90
}

[dir] .ql-editor .ql-bg-yellow {
    background-color: #ff0
}

[dir] .ql-editor .ql-bg-green {
    background-color: #008a00
}

[dir] .ql-editor .ql-bg-blue {
    background-color: #06c
}

[dir] .ql-editor .ql-bg-purple {
    background-color: #93f
}

.ql-editor .ql-color-white {
    color: #fff
}

.ql-editor .ql-color-red {
    color: #e60000
}

.ql-editor .ql-color-orange {
    color: #f90
}

.ql-editor .ql-color-yellow {
    color: #ff0
}

.ql-editor .ql-color-green {
    color: #008a00
}

.ql-editor .ql-color-blue {
    color: #06c
}

.ql-editor .ql-color-purple {
    color: #93f
}

.ql-editor .ql-font-serif {
    font-family: Georgia,Times New Roman,serif
}

.ql-editor .ql-font-monospace {
    font-family: Monaco,Courier New,monospace
}

.ql-editor .ql-size-small {
    font-size: .75em
}

.ql-editor .ql-size-large {
    font-size: 1.5em
}

.ql-editor .ql-size-huge {
    font-size: 2.5em
}

[dir] .ql-editor .ql-direction-rtl {
    text-align: inherit
}

[dir=ltr] .ql-editor .ql-direction-rtl {
    direction: rtl
}

[dir=rtl] .ql-editor .ql-direction-rtl {
    direction: ltr
}

[dir] .ql-editor .ql-align-center {
    text-align: center
}

[dir] .ql-editor .ql-align-justify {
    text-align: justify
}

[dir=ltr] .ql-editor .ql-align-right {
    text-align: right
}

[dir=rtl] .ql-editor .ql-align-right {
    text-align: left
}

.ql-editor .ql-ui {
    position: absolute
}

.ql-editor.ql-blank:before {
    color: rgba(0,0,0,.6);
    content: attr(data-placeholder);
    font-style: italic;
    pointer-events: none;
    position: absolute
}

[dir=ltr] .ql-editor.ql-blank:before,[dir=rtl] .ql-editor.ql-blank:before {
    left: 15px;
    right: 15px
}

.ql-bubble.ql-toolbar:after,.ql-bubble .ql-toolbar:after {
    content: "";
    display: table
}

[dir] .ql-bubble.ql-toolbar:after,[dir] .ql-bubble .ql-toolbar:after {
    clear: both
}

.ql-bubble.ql-toolbar button,.ql-bubble .ql-toolbar button {
    display: inline-block;
    height: 24px;
    width: 28px
}

[dir] .ql-bubble.ql-toolbar button,[dir] .ql-bubble .ql-toolbar button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 3px 5px
}

[dir=ltr] .ql-bubble.ql-toolbar button,[dir=ltr] .ql-bubble .ql-toolbar button {
    float: left
}

[dir=rtl] .ql-bubble.ql-toolbar button,[dir=rtl] .ql-bubble .ql-toolbar button {
    float: right
}

.ql-bubble.ql-toolbar button svg,.ql-bubble .ql-toolbar button svg {
    height: 100%
}

[dir=ltr] .ql-bubble.ql-toolbar button svg,[dir=ltr] .ql-bubble .ql-toolbar button svg {
    float: left
}

[dir=rtl] .ql-bubble.ql-toolbar button svg,[dir=rtl] .ql-bubble .ql-toolbar button svg {
    float: right
}

.ql-bubble.ql-toolbar button:active:hover,.ql-bubble .ql-toolbar button:active:hover {
    outline: none
}

.ql-bubble.ql-toolbar input.ql-image[type=file],.ql-bubble .ql-toolbar input.ql-image[type=file] {
    display: none
}

.ql-bubble.ql-toolbar .ql-picker-item.ql-selected,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected,.ql-bubble.ql-toolbar .ql-picker-item:hover,.ql-bubble .ql-toolbar .ql-picker-item:hover,.ql-bubble.ql-toolbar .ql-picker-label.ql-active,.ql-bubble .ql-toolbar .ql-picker-label.ql-active,.ql-bubble.ql-toolbar .ql-picker-label:hover,.ql-bubble .ql-toolbar .ql-picker-label:hover,.ql-bubble.ql-toolbar button.ql-active,.ql-bubble .ql-toolbar button.ql-active,.ql-bubble.ql-toolbar button:focus,.ql-bubble .ql-toolbar button:focus,.ql-bubble.ql-toolbar button:hover,.ql-bubble .ql-toolbar button:hover {
    color: #fff
}

.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button.ql-active .ql-fill,.ql-bubble .ql-toolbar button.ql-active .ql-fill,.ql-bubble.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button:focus .ql-fill,.ql-bubble .ql-toolbar button:focus .ql-fill,.ql-bubble.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button:hover .ql-fill,.ql-bubble .ql-toolbar button:hover .ql-fill,.ql-bubble.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:hover .ql-stroke.ql-fill {
    fill: #fff
}

.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-bubble.ql-toolbar button.ql-active .ql-stroke,.ql-bubble .ql-toolbar button.ql-active .ql-stroke,.ql-bubble.ql-toolbar button.ql-active .ql-stroke-miter,.ql-bubble .ql-toolbar button.ql-active .ql-stroke-miter,.ql-bubble.ql-toolbar button:focus .ql-stroke,.ql-bubble .ql-toolbar button:focus .ql-stroke,.ql-bubble.ql-toolbar button:focus .ql-stroke-miter,.ql-bubble .ql-toolbar button:focus .ql-stroke-miter,.ql-bubble.ql-toolbar button:hover .ql-stroke,.ql-bubble .ql-toolbar button:hover .ql-stroke,.ql-bubble.ql-toolbar button:hover .ql-stroke-miter,.ql-bubble .ql-toolbar button:hover .ql-stroke-miter {
    stroke: #fff
}

@media (pointer: coarse) {
    .ql-bubble.ql-toolbar button:hover:not(.ql-active),.ql-bubble .ql-toolbar button:hover:not(.ql-active) {
        color:#ccc
    }

    .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
        fill: #ccc
    }

    .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
        stroke: #ccc
    }
}

.ql-bubble,.ql-bubble * {
    box-sizing: border-box
}

.ql-bubble .ql-hidden {
    display: none
}

.ql-bubble .ql-out-bottom,.ql-bubble .ql-out-top {
    visibility: hidden
}

.ql-bubble .ql-tooltip {
    position: absolute
}

[dir] .ql-bubble .ql-tooltip {
    transform: translateY(10px)
}

.ql-bubble .ql-tooltip a {
    text-decoration: none
}

[dir] .ql-bubble .ql-tooltip a {
    cursor: pointer
}

[dir] .ql-bubble .ql-tooltip.ql-flip {
    transform: translateY(-10px)
}

.ql-bubble .ql-formats {
    display: inline-block;
    vertical-align: middle
}

.ql-bubble .ql-formats:after {
    content: "";
    display: table
}

[dir] .ql-bubble .ql-formats:after {
    clear: both
}

.ql-bubble .ql-stroke {
    fill: none;
    stroke: #ccc;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2
}

.ql-bubble .ql-stroke-miter {
    fill: none;
    stroke: #ccc;
    stroke-miterlimit: 10;
    stroke-width: 2
}

.ql-bubble .ql-fill,.ql-bubble .ql-stroke.ql-fill {
    fill: #ccc
}

.ql-bubble .ql-empty {
    fill: none
}

.ql-bubble .ql-even {
    fill-rule: evenodd
}

.ql-bubble .ql-stroke.ql-thin,.ql-bubble .ql-thin {
    stroke-width: 1
}

.ql-bubble .ql-transparent {
    opacity: .4
}

.ql-bubble .ql-direction svg:last-child {
    display: none
}

.ql-bubble .ql-direction.ql-active svg:last-child {
    display: inline
}

.ql-bubble .ql-direction.ql-active svg:first-child {
    display: none
}

.ql-bubble .ql-editor h1 {
    font-size: 2em
}

.ql-bubble .ql-editor h2 {
    font-size: 1.5em
}

.ql-bubble .ql-editor h3 {
    font-size: 1.17em
}

.ql-bubble .ql-editor h4 {
    font-size: 1em
}

.ql-bubble .ql-editor h5 {
    font-size: .83em
}

.ql-bubble .ql-editor h6 {
    font-size: .67em
}

.ql-bubble .ql-editor a {
    text-decoration: underline
}

[dir] .ql-bubble .ql-editor blockquote {
    margin-bottom: 5px;
    margin-top: 5px
}

[dir=ltr] .ql-bubble .ql-editor blockquote {
    border-left: 4px solid #ccc;
    padding-left: 16px
}

[dir=rtl] .ql-bubble .ql-editor blockquote {
    border-right: 4px solid #ccc;
    padding-right: 16px
}

[dir] .ql-bubble .ql-editor .ql-code-block-container,[dir] .ql-bubble .ql-editor code {
    background-color: #f0f0f0;
    border-radius: 3px
}

[dir] .ql-bubble .ql-editor .ql-code-block-container {
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 5px 10px
}

.ql-bubble .ql-editor code {
    font-size: 85%
}

[dir] .ql-bubble .ql-editor code {
    padding: 2px 4px
}

.ql-bubble .ql-editor .ql-code-block-container {
    color: #f8f8f2;
    overflow: visible
}

[dir] .ql-bubble .ql-editor .ql-code-block-container {
    background-color: #23241f
}

.ql-bubble .ql-editor img {
    max-width: 100%
}

.ql-bubble .ql-picker {
    color: #ccc;
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    height: 24px;
    position: relative;
    vertical-align: middle
}

[dir=ltr] .ql-bubble .ql-picker {
    float: left
}

[dir=rtl] .ql-bubble .ql-picker {
    float: right
}

.ql-bubble .ql-picker-label {
    display: inline-block;
    height: 100%;
    position: relative;
    width: 100%
}

[dir] .ql-bubble .ql-picker-label {
    cursor: pointer
}

[dir=ltr] .ql-bubble .ql-picker-label {
    padding-left: 8px;
    padding-right: 2px
}

[dir=rtl] .ql-bubble .ql-picker-label {
    padding-right: 8px;
    padding-left: 2px
}

.ql-bubble .ql-picker-label:before {
    display: inline-block;
    line-height: 22px
}

.ql-bubble .ql-picker-options {
    display: none;
    min-width: 100%;
    position: absolute;
    white-space: nowrap
}

[dir] .ql-bubble .ql-picker-options {
    background-color: #444;
    padding: 4px 8px
}

.ql-bubble .ql-picker-options .ql-picker-item {
    display: block
}

[dir] .ql-bubble .ql-picker-options .ql-picker-item {
    cursor: pointer;
    padding-bottom: 5px;
    padding-top: 5px
}

.ql-bubble .ql-picker.ql-expanded .ql-picker-label {
    color: #777;
    z-index: 2
}

.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-fill {
    fill: #777
}

.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
    stroke: #777
}

.ql-bubble .ql-picker.ql-expanded .ql-picker-options {
    display: block;
    top: 100%;
    z-index: 1
}

[dir] .ql-bubble .ql-picker.ql-expanded .ql-picker-options {
    margin-top: -1px
}

.ql-bubble .ql-color-picker,.ql-bubble .ql-icon-picker {
    width: 28px
}

[dir] .ql-bubble .ql-color-picker .ql-picker-label,[dir] .ql-bubble .ql-icon-picker .ql-picker-label {
    padding: 2px 4px
}

[dir=ltr] .ql-bubble .ql-color-picker .ql-picker-label svg,[dir=ltr] .ql-bubble .ql-icon-picker .ql-picker-label svg {
    right: 4px
}

[dir=rtl] .ql-bubble .ql-color-picker .ql-picker-label svg,[dir=rtl] .ql-bubble .ql-icon-picker .ql-picker-label svg {
    left: 4px
}

[dir] .ql-bubble .ql-icon-picker .ql-picker-options {
    padding: 4px 0
}

.ql-bubble .ql-icon-picker .ql-picker-item {
    height: 24px;
    width: 24px
}

[dir] .ql-bubble .ql-icon-picker .ql-picker-item {
    padding: 2px 4px
}

.ql-bubble .ql-color-picker .ql-picker-options {
    width: 152px
}

[dir] .ql-bubble .ql-color-picker .ql-picker-options {
    padding: 3px 5px
}

.ql-bubble .ql-color-picker .ql-picker-item {
    height: 16px;
    width: 16px
}

[dir] .ql-bubble .ql-color-picker .ql-picker-item {
    border: 1px solid transparent;
    margin: 2px;
    padding: 0
}

[dir=ltr] .ql-bubble .ql-color-picker .ql-picker-item {
    float: left
}

[dir=rtl] .ql-bubble .ql-color-picker .ql-picker-item {
    float: right
}

.ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    position: absolute;
    top: 50%;
    width: 18px
}

[dir] .ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    margin-top: -9px
}

[dir=ltr] .ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    right: 0
}

[dir=rtl] .ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    left: 0
}

.ql-bubble .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=""]):before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=""]):before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=""]):before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=""]):before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=""]):before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=""]):before {
    content: attr(data-label)
}

.ql-bubble .ql-picker.ql-header {
    width: 98px
}

.ql-bubble .ql-picker.ql-header .ql-picker-item:before,.ql-bubble .ql-picker.ql-header .ql-picker-label:before {
    content: "Normal"
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="1"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="1"]:before {
    content: "Heading 1"
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="2"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="2"]:before {
    content: "Heading 2"
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="3"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="3"]:before {
    content: "Heading 3"
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="4"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="4"]:before {
    content: "Heading 4"
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="5"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="5"]:before {
    content: "Heading 5"
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="6"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="6"]:before {
    content: "Heading 6"
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="1"]:before {
    font-size: 2em
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="2"]:before {
    font-size: 1.5em
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="3"]:before {
    font-size: 1.17em
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="4"]:before {
    font-size: 1em
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="5"]:before {
    font-size: .83em
}

.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="6"]:before {
    font-size: .67em
}

.ql-bubble .ql-picker.ql-font {
    width: 108px
}

.ql-bubble .ql-picker.ql-font .ql-picker-item:before,.ql-bubble .ql-picker.ql-font .ql-picker-label:before {
    content: "Sans Serif"
}

.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]:before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=serif]:before {
    content: "Serif"
}

.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before {
    content: "Monospace"
}

.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]:before {
    font-family: Georgia,Times New Roman,serif
}

.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before {
    font-family: Monaco,Courier New,monospace
}

.ql-bubble .ql-picker.ql-size {
    width: 98px
}

.ql-bubble .ql-picker.ql-size .ql-picker-item:before,.ql-bubble .ql-picker.ql-size .ql-picker-label:before {
    content: "Normal"
}

.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]:before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=small]:before {
    content: "Small"
}

.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]:before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=large]:before {
    content: "Large"
}

.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]:before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=huge]:before {
    content: "Huge"
}

.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]:before {
    font-size: 10px
}

.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]:before {
    font-size: 18px
}

.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]:before {
    font-size: 32px
}

[dir] .ql-bubble .ql-color-picker.ql-background .ql-picker-item {
    background-color: #fff
}

[dir] .ql-bubble .ql-color-picker.ql-color .ql-picker-item {
    background-color: #000
}

.ql-code-block-container {
    position: relative
}

.ql-code-block-container .ql-ui {
    top: 5px
}

[dir=ltr] .ql-code-block-container .ql-ui {
    right: 5px
}

[dir=rtl] .ql-code-block-container .ql-ui {
    left: 5px
}

[dir=ltr] .ql-bubble .ql-toolbar .ql-formats {
    margin: 8px 12px 8px 0
}

[dir=rtl] .ql-bubble .ql-toolbar .ql-formats {
    margin: 8px 0 8px 12px
}

[dir=ltr] .ql-bubble .ql-toolbar .ql-formats:first-child {
    margin-left: 12px
}

[dir=rtl] .ql-bubble .ql-toolbar .ql-formats:first-child {
    margin-right: 12px
}

[dir] .ql-bubble .ql-color-picker svg {
    margin: 1px
}

[dir] .ql-bubble .ql-color-picker .ql-picker-item.ql-selected,[dir] .ql-bubble .ql-color-picker .ql-picker-item:hover {
    border-color: #fff
}

.ql-bubble .ql-tooltip {
    color: #fff
}

[dir] .ql-bubble .ql-tooltip {
    background-color: #444;
    border-radius: 25px
}

.ql-bubble .ql-tooltip-arrow {
    content: " ";
    display: block;
    position: absolute
}

[dir=ltr] .ql-bubble .ql-tooltip-arrow {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    left: 50%;
    margin-left: -6px
}

[dir=rtl] .ql-bubble .ql-tooltip-arrow {
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    right: 50%;
    margin-right: -6px
}

.ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow {
    top: -6px
}

[dir] .ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow {
    border-bottom: 6px solid #444
}

.ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow {
    bottom: -6px
}

[dir] .ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow {
    border-top: 6px solid #444
}

.ql-bubble .ql-tooltip.ql-editing .ql-tooltip-editor {
    display: block
}

.ql-bubble .ql-tooltip.ql-editing .ql-formats {
    visibility: hidden
}

.ql-bubble .ql-tooltip-editor {
    display: none
}

.ql-bubble .ql-tooltip-editor input[type=text] {
    color: #fff;
    font-size: 13px;
    height: 100%;
    outline: none;
    position: absolute;
    width: 100%
}

[dir] .ql-bubble .ql-tooltip-editor input[type=text] {
    background: transparent;
    border: none;
    padding: 10px 20px
}

.ql-bubble .ql-tooltip-editor a {
    top: 10px;
    position: absolute
}

[dir=ltr] .ql-bubble .ql-tooltip-editor a {
    right: 20px
}

[dir=rtl] .ql-bubble .ql-tooltip-editor a {
    left: 20px
}

.ql-bubble .ql-tooltip-editor a:before {
    color: #ccc;
    content: "\D7";
    font-size: 16px;
    font-weight: 700
}

.ql-container.ql-bubble:not(.ql-disabled) a {
    position: relative;
    white-space: nowrap
}

.ql-container.ql-bubble:not(.ql-disabled) a:before {
    top: -5px;
    font-size: 12px;
    color: #fff;
    content: attr(href);
    font-weight: 400;
    overflow: hidden;
    text-decoration: none;
    z-index: 1
}

[dir] .ql-container.ql-bubble:not(.ql-disabled) a:before {
    background-color: #444;
    border-radius: 15px;
    padding: 5px 15px
}

.ql-container.ql-bubble:not(.ql-disabled) a:after {
    top: 0;
    content: " ";
    height: 0;
    width: 0
}

[dir] .ql-container.ql-bubble:not(.ql-disabled) a:after {
    border-top: 6px solid #444
}

[dir=ltr] .ql-container.ql-bubble:not(.ql-disabled) a:after,[dir=rtl] .ql-container.ql-bubble:not(.ql-disabled) a:after {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent
}

.ql-container.ql-bubble:not(.ql-disabled) a:after,.ql-container.ql-bubble:not(.ql-disabled) a:before {
    position: absolute;
    transition: visibility 0s ease .2s;
    visibility: hidden
}

[dir=ltr] .ql-container.ql-bubble:not(.ql-disabled) a:after,[dir=ltr] .ql-container.ql-bubble:not(.ql-disabled) a:before {
    left: 0;
    margin-left: 50%;
    transform: translate(-50%,-100%)
}

[dir=rtl] .ql-container.ql-bubble:not(.ql-disabled) a:after,[dir=rtl] .ql-container.ql-bubble:not(.ql-disabled) a:before {
    right: 0;
    margin-right: 50%;
    transform: translate(50%,-100%)
}

.ql-container.ql-bubble:not(.ql-disabled) a:hover:after,.ql-container.ql-bubble:not(.ql-disabled) a:hover:before {
    visibility: visible
}

.toastification-close-icon[data-v-55dd3057],.toastification-title[data-v-55dd3057] {
    line-height: 26px
}

.toastification-title[data-v-55dd3057] {
    color: inherit
}

[contenteditable][placeholder][data-v-5b375260]:empty {
    color: #c1c1c1
}

[contenteditable][data-v-5b375260]:focus {
    outline: none
}

[dir] [contenteditable][data-v-5b375260] {
    border: 1px solid #c1c1c1;
    padding: 5px;
    border-radius: 4px
}

[contenteditable=true][data-v-5b375260]:empty:before {
    content: attr(placeholder);
    pointer-events: none;
    display: block;
    color: #8f8f8f
}

[contenteditable][placeholder][data-v-717c2f52]:empty {
    color: #c1c1c1
}

[contenteditable][data-v-717c2f52]:focus {
    outline: none
}

[dir] [contenteditable][data-v-717c2f52] {
    border: 1px solid #c1c1c1;
    padding: 5px;
    border-radius: 4px
}

[contenteditable=true][data-v-717c2f52]:empty:before {
    content: attr(placeholder);
    pointer-events: none;
    display: block;
    color: #8f8f8f
}

[dir] .panel-edit .ql-editor {
    padding: 5px;
    border: 1px solid #9b9b9b;
    border-radius: 3px
}

.question__image-box[data-v-18048122] {
    position: relative
}

.btn-pick-image[data-v-18048122] {
    position: absolute
}

.question__image-box .btn-pick-image[data-v-18048122] {
    opacity: 0;
    transition: all .2s
}

.question__image-box:hover .btn-pick-image[data-v-18048122] {
    opacity: 1
}

.question__image-box .btn-pick-image.no-image[data-v-18048122] {
    opacity: 1!important
}

.tick__image-block[data-v-a40caeda] {
    height: 250px;
    width: 250px
}

[dir] .tick__image-block[data-v-a40caeda] {
    border-bottom: 1px solid #ededed;
    margin-bottom: 10px
}

.tick-item[data-v-a40caeda] {
    width: 250px;
    height: 300px;
    position: relative
}

[dir] .tick-item[data-v-a40caeda] {
    box-shadow: 0 4px 13px -6px rgba(0,0,0,.34)
}

.tick-item .btn-remove[data-v-a40caeda] {
    position: absolute;
    top: 0;
    opacity: 0;
    transition: all .2s;
    z-index: 9999999
}

[dir=ltr] .tick-item .btn-remove[data-v-a40caeda] {
    right: 0
}

[dir=rtl] .tick-item .btn-remove[data-v-a40caeda] {
    left: 0
}

.tick-item:hover .btn-remove[data-v-a40caeda] {
    opacity: 1
}

.btn-add-row[data-v-aabfbea8] {
    color: #fff;
    width: fit-content
}

[dir] .btn-add-row[data-v-aabfbea8] {
    background-color: #0656a6;
    padding: 2px 10px;
    border-radius: 5px;
    margin-top: 10px;
    cursor: pointer
}

.btn-remove-item[data-v-aabfbea8] {
    color: #ff2a2a
}

[dir=ltr] .btn-remove-item[data-v-aabfbea8] {
    margin-right: 4px
}

[dir=rtl] .btn-remove-item[data-v-aabfbea8] {
    margin-left: 4px
}

[dir] .question-row[data-v-aabfbea8] {
    margin-bottom: 10px;
    margin-top: 10px
}

[contenteditable=true]:empty:before {
    content: attr(placeholder);
    pointer-events: none;
    display: block
}

.tick__image-block[data-v-ee109e80] {
    height: 250px;
    width: 250px
}

[dir] .tick__image-block[data-v-ee109e80] {
    border-bottom: 1px solid #ededed;
    margin-bottom: 10px
}

.tick-item[data-v-ee109e80] {
    width: 250px;
    height: 300px;
    position: relative
}

[dir] .tick-item[data-v-ee109e80] {
    box-shadow: 0 4px 13px -6px rgba(0,0,0,.34)
}

.tick-item .btn-remove[data-v-ee109e80] {
    position: absolute;
    top: 0;
    opacity: 0;
    transition: all .2s;
    z-index: 9999999
}

[dir=ltr] .tick-item .btn-remove[data-v-ee109e80] {
    right: 0
}

[dir=rtl] .tick-item .btn-remove[data-v-ee109e80] {
    left: 0
}

.tick-item:hover .btn-remove[data-v-ee109e80] {
    opacity: 1
}

.btn-remove-item[data-v-f2b28ae6] {
    position: absolute;
    top: 10px;
    color: red
}

[dir] .btn-remove-item[data-v-f2b28ae6] {
    cursor: pointer
}

[dir=ltr] .btn-remove-item[data-v-f2b28ae6] {
    right: 10px
}

[dir=rtl] .btn-remove-item[data-v-f2b28ae6] {
    left: 10px
}

.btn-add-correct-answer[data-v-f2b28ae6] {
    color: #0656a6;
    display: block
}

[dir] .btn-add-correct-answer[data-v-f2b28ae6] {
    text-align: center;
    margin-top: 10px!important;
    margin-bottom: 0!important;
    cursor: pointer
}

.choose-correct-answer .questions .question-item[data-v-f2b28ae6] {
    position: relative;
    min-height: 70px
}

[dir] .choose-correct-answer .questions .question-item[data-v-f2b28ae6] {
    margin-bottom: 25px;
    padding: 6px;
    box-shadow: 0 0 5px -2px rgba(0,0,0,.9490196078431372);
    border-radius: 4px
}

.radio-check>div[data-v-0a024436] {
    height: 50px;
    width: 50px
}

[dir] .radio-check>div[data-v-0a024436] {
    border: 5px solid #000;
    border-radius: 5px
}

[dir=ltr] .radio-check>div[data-v-0a024436] {
    margin-right: 20px
}

[dir=rtl] .radio-check>div[data-v-0a024436] {
    margin-left: 20px
}

.radio-check[data-v-0a024436] {
    display: flex
}

.radio-check>div>img[data-v-0a024436] {
    height: 40px;
    width: 40px
}

.tick__image-block[data-v-a0a9e884] {
    height: 250px;
    width: 250px;
    min-height: 250px;
    min-width: 250px
}

[dir] .tick__image-block[data-v-a0a9e884] {
    border-bottom: 1px solid #ededed;
    margin-bottom: 15px
}

[dir=ltr] .tick__image-block[data-v-a0a9e884] {
    margin-right: 50px
}

[dir=rtl] .tick__image-block[data-v-a0a9e884] {
    margin-left: 50px
}

.tick-item[data-v-a0a9e884] {
    height: 250px;
    position: relative
}

[dir] .tick-item[data-v-a0a9e884] {
    box-shadow: 0 4px 13px -6px rgba(0,0,0,.34)
}

.tick-item .btn-remove[data-v-a0a9e884] {
    position: absolute;
    top: 0;
    opacity: 0;
    transition: all .2s;
    z-index: 9999999
}

[dir=ltr] .tick-item .btn-remove[data-v-a0a9e884] {
    right: 0
}

[dir=rtl] .tick-item .btn-remove[data-v-a0a9e884] {
    left: 0
}

.tick-item:hover .btn-remove[data-v-a0a9e884] {
    opacity: 1
}

.btn-add-correct-answer[data-v-977ff924] {
    color: #0656a6;
    display: block
}

[dir] .btn-add-correct-answer[data-v-977ff924] {
    text-align: center;
    margin-top: 10px!important;
    margin-bottom: 0!important;
    cursor: pointer
}

.choose-correct-answer .questions .question-item[data-v-977ff924] {
    min-height: 70px
}

[dir] .choose-correct-answer .questions .question-item[data-v-977ff924] {
    margin-bottom: 25px;
    padding: 6px;
    box-shadow: 0 0 5px -2px rgba(0,0,0,.9490196078431372);
    border-radius: 4px
}

.btn-remove-item[data-v-5b07a7b6] {
    color: #ff2a2a
}

[dir] .btn-remove-item[data-v-5b07a7b6] {
    cursor: pointer;
    margin: 4px
}

[dir=ltr] .btn-remove-item[data-v-5b07a7b6] {
    margin-right: 4px
}

[dir=rtl] .btn-remove-item[data-v-5b07a7b6] {
    margin-left: 4px
}

.btn-add-correct-answer[data-v-5b07a7b6] {
    color: #0656a6;
    display: block
}

[dir] .btn-add-correct-answer[data-v-5b07a7b6] {
    text-align: center;
    margin-top: 10px!important;
    margin-bottom: 0!important;
    cursor: pointer
}

.choose-correct-answer .questions .question-item[data-v-5b07a7b6] {
    min-height: 70px
}

[dir] .choose-correct-answer .questions .question-item[data-v-5b07a7b6] {
    margin-bottom: 25px;
    padding: 6px;
    box-shadow: 0 0 5px -2px rgba(0,0,0,.9490196078431372);
    border-radius: 4px
}

.text-tag {
    display: inline;
    font-weight: 700
}

[dir] .text-tag {
    background-color: #d7d7d7;
    border-radius: 4px;
    padding: 2px
}

.select-panel[data-v-f05acd3e] {
    display: none;
    position: absolute
}

[dir] .select-panel[data-v-f05acd3e] {
    background-color: #fff;
    box-shadow: 0 0 20px 0 rgba(0,0,0,.30196078431372547);
    border-radius: 5px;
    border: 1px solid
}

.select-panel.open[data-v-f05acd3e] {
    display: block
}

[dir] .select-panel .select-item[data-v-f05acd3e] {
    cursor: pointer;
    padding: 5px 15px
}

.select-panel .select-item[data-v-f05acd3e]:hover {
    color: #fff
}

[dir] .select-panel .select-item[data-v-f05acd3e]:hover {
    background-color: #0156a6
}

[contenteditable=true][data-v-f05acd3e] {
    display: inline-block;
    white-space: pre-wrap
}

[contenteditable][placeholder][data-v-f05acd3e]:empty {
    color: #c1c1c1
}

[contenteditable][data-v-f05acd3e]:focus {
    outline: none
}

[dir] [contenteditable][data-v-f05acd3e] {
    border: 1px solid #c1c1c1;
    padding: 5px;
    border-radius: 4px
}

[contenteditable=true][data-v-f05acd3e]:empty:before {
    content: attr(placeholder);
    pointer-events: none;
    display: block
}

.btn-add-correct-answer[data-v-7ac3238e] {
    color: #0656a6;
    display: block
}

[dir] .btn-add-correct-answer[data-v-7ac3238e] {
    text-align: center;
    margin-top: 10px!important;
    margin-bottom: 0!important;
    cursor: pointer
}

.choose-correct-answer .questions .question-item[data-v-7ac3238e] {
    min-height: 70px
}

[dir] .choose-correct-answer .questions .question-item[data-v-7ac3238e] {
    margin-bottom: 25px;
    padding: 6px;
    box-shadow: 0 0 5px -2px rgba(0,0,0,.9490196078431372);
    border-radius: 4px
}

.btn-add-correct-answer[data-v-6083d72d] {
    color: #0656a6;
    display: block
}

[dir] .btn-add-correct-answer[data-v-6083d72d] {
    text-align: center;
    margin-top: 10px!important;
    margin-bottom: 0!important;
    cursor: pointer
}

.choose-correct-answer .questions .question-item[data-v-6083d72d] {
    min-height: 70px
}

[dir] .choose-correct-answer .questions .question-item[data-v-6083d72d] {
    margin-bottom: 25px;
    padding: 6px;
    box-shadow: 0 0 5px -2px rgba(0,0,0,.9490196078431372);
    border-radius: 4px
}

.btn-add-correct-answer[data-v-193eb19a] {
    color: #0656a6;
    display: block
}

[dir] .btn-add-correct-answer[data-v-193eb19a] {
    text-align: center;
    margin-top: 10px!important;
    margin-bottom: 0!important;
    cursor: pointer
}

.choose-correct-answer .questions .question-item[data-v-193eb19a] {
    min-height: 70px
}

[dir] .choose-correct-answer .questions .question-item[data-v-193eb19a] {
    margin-bottom: 25px;
    padding: 6px;
    box-shadow: 0 0 5px -2px rgba(0,0,0,.9490196078431372);
    border-radius: 4px
}

[dir] .setting-panel .panel-header[data-v-c50273ec] {
    border-bottom: 1px solid #e9e9e9;
    box-shadow: 0 2px 7px -1px rgba(0,0,0,.0392156862745098);
    background-color: #f7f7f7;
    border-radius: 4px
}

.panel-edit[data-v-92271a60] {
    min-height: 600px;
    display: flex
}

[dir] .panel-left[data-v-92271a60] {
    padding: 5px
}

.panel-edit .panel-left[data-v-92271a60] {
    min-width: 300px
}

[dir] .panel-edit .panel-left[data-v-92271a60] {
    border: 1px solid #d8d8d8;
    border-radius: 5px
}

[dir=ltr] .panel-edit .panel-left[data-v-92271a60] {
    margin-right: 20px
}

[dir=rtl] .panel-edit .panel-left[data-v-92271a60] {
    margin-left: 20px
}

.panel-edit .panel-right[data-v-92271a60] {
    width: calc(100% - 320px)
}

[dir] .panel-edit .panel-right[data-v-92271a60] {
    border: 1px solid #d8d8d8;
    border-radius: 5px
}

.list-style-1 li[data-v-92271a60] {
    color: #605d5d
}

[dir] .list-style-1 li[data-v-92271a60] {
    padding: 10px;
    background-color: #f9f9f9;
    margin-top: 5px;
    margin-bottom: 5px;
    border-radius: 5px;
    cursor: pointer;
    border: 1px solid #d1d1d1
}

.list-style-1 li.selected[data-v-92271a60] {
    color: #fff
}

[dir] .list-style-1 li.selected[data-v-92271a60] {
    background-color: #3a6081
}

.panel-edit .page-item[data-v-92271a60] {
    color: #fff;
    position: relative;
    transition: all .2s
}

[dir] .panel-edit .page-item[data-v-92271a60] {
    padding: 12px 15px;
    margin: 14px 0;
    background-color: #bdae44;
    border-radius: 5px!important;
    cursor: pointer
}

[dir] .panel-edit .page-item.selected[data-v-92271a60],[dir] .panel-edit .page-item[data-v-92271a60]:hover {
    background-color: #897c26
}

.panel-edit .page-item .flex-button[data-v-92271a60] {
    position: absolute;
    color: #0656a6;
    font-size: .9rem;
    opacity: 0;
    transition: all .2s
}

[dir=ltr] .panel-edit .page-item .flex-button[data-v-92271a60] {
    left: 50%;
    transform: translateX(-50%)
}

[dir=rtl] .panel-edit .page-item .flex-button[data-v-92271a60] {
    right: 50%;
    transform: translateX(50%)
}

.panel-edit .page-item .btn-remove[data-v-92271a60] {
    color: #fff;
    top: 0;
    display: block;
    position: absolute;
    opacity: 0;
    transition: all .2s;
    z-index: 99
}

[dir] .panel-edit .page-item .btn-remove[data-v-92271a60] {
    background-color: #b3a33e;
    padding: 5px
}

[dir=ltr] .panel-edit .page-item .btn-remove[data-v-92271a60] {
    right: 0;
    border-radius: 0 5px 0 0
}

[dir=rtl] .panel-edit .page-item .btn-remove[data-v-92271a60] {
    left: 0;
    border-radius: 5px 0 0 0
}

.panel-edit .page-item:hover .btn-remove[data-v-92271a60] {
    opacity: 1
}

.panel-edit .page-item .flex-button.top[data-v-92271a60] {
    top: -25px
}

.panel-edit .page-item .flex-button.bottom[data-v-92271a60] {
    bottom: -25px
}

.panel-edit .page-item:hover .flex-button[data-v-92271a60] {
    opacity: 1
}

[contenteditable][placeholder][data-v-92271a60]:empty {
    color: #c1c1c1
}

[contenteditable][data-v-92271a60]:focus {
    outline: none
}

[dir] [contenteditable][data-v-92271a60] {
    border: 1px solid #c1c1c1;
    padding: 5px;
    border-radius: 4px
}

.ql-editor .h6,.ql-editor h6 {
    font-size: 1rem!important
}

.ql-editor .h5,.ql-editor h5 {
    font-size: 1.25rem!important
}

.ql-editor .h4,.ql-editor h4 {
    font-size: 1.5rem!important
}

.ql-editor .h3,.ql-editor h3 {
    font-size: 1.75rem!important
}

.ql-editor .h2,.ql-editor h2 {
    font-size: 2rem!important
}

.ql-editor .h1,.ql-editor h1 {
    font-size: 2.5rem!important
}

.answer-remove-button {
    color: #fff
}

[dir] .answer-remove-button {
    border: none;
    background-color: #ff4949;
    border-radius: 5px
}

.question-content img {
    max-height: 300px;
    width: auto
}

span.question-count {
    font-size: 1.2rem;
    font-weight: 700;
    color: #12508f
}

.question-content * {
    color: #12508f!important
}

ul.question-option {
    list-style: none;
    width: max-content
}

[dir] ul.question-option {
    padding: 0
}

ul.question-option li {
    color: #12508f!important;
    font-weight: 500;
    display: flex
}

[dir] ul.question-option li {
    padding: 5px 10px;
    background-color: #e1ebf3;
    border-radius: 10px;
    margin-bottom: 5px
}

.question-option .option-badge {
    display: block;
    width: 23px;
    height: 23px
}

[dir] .question-option .option-badge {
    border: 1px solid #12508f;
    border-radius: 22px;
    text-align: center
}

[dir=ltr] .question-option .option-badge {
    margin-right: 8px
}

[dir=rtl] .question-option .option-badge {
    margin-left: 8px
}

.question-option .option-badge.checked {
    color: #fff
}

[dir] .question-option .option-badge.checked {
    background-color: #12508f
}

[dir] .question-content.type-note {
    padding: 10px
}

[dir] input.question-input {
    border: 1px solid #12508f;
    border-radius: 22px;
    padding: 4px 20px
}

audio.voice {
    display: inherit
}

[dir] audio.voice {
    margin: auto
}

</style>